module.exports = __webpack_public_path__ + "static/accounts_ibm_cloud_1-f7585cbf73a280c42ca2afa0b2e20511.png";